<template>
  <div class="main">
    <el-select
      :value="userValue"
      :multiple="multiple"
      :placeholder="placeholder"
      v-bind="$attrs"
      filterable
      :collapse-tags="isDisabled?false:true"
      class="width-layout"
      @change="handleChange"
      @visible-change="handleVisibleChange"
    >
      <el-option
        v-for="item in userList"
        :key="item.id"
        :label="item.adminName"
        :value="item.adminUid"
        :disabled="isOptionSelected(item)"
      />
    </el-select>
  </div>
</template>

<script>
import mixin from '../../../mixins/auditFlowManage'
import cloneDeep from 'lodash/cloneDeep'

const numberReg = /^[0-9]*$/
const chineseReg = /[\u4E00-\u9FA5\uF900-\uFA2D]{1,}/
export default {
  name: 'accountUserSelect',
  mixins: [mixin],
  model: {
    prop: 'value',
    event: 'change',
  },
  props: {
    multiple: {
      type: Boolean,
      default: true,
    },
    placeholder: {
      type: String,
      default: '请选择',
    },
    value: {
      type: [String, Number, Array],
      default: () => [],
    },
    isDisabled: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      loading: false,
      userValue: [],
      userList: [],
      // eslint-disable-next-line vue/no-unused-properties
      params: { userType: 1, status: 1 },
      cloneUserList: [],
    }
  },
  watch: {
    value: {
      handler() {
        this.getSelected()
      },
      immediate: true,
      deep: true,
    },
  },
  async created() {
    // 无数据情况再去请求接口
    if (this.accountList && this.accountList.length) {
      this.userList = this.accountList
    } else {
      await this.loadUserList()
    }
    this.cloneUserList = cloneDeep(this.userList)
    this.getSelected()
  },
  methods: {
    async loadUserList(val) {
      try {
        const submitParams = {
          ...this.params,
        }
        if (val && numberReg.test(val)) {
          submitParams.userMobile = val
        } else if (chineseReg.test(val)) {
          submitParams.userName = val
        } else if (val) {
          submitParams.userAccount = val
        }
        this.loading = true
        this.userList = this.accountList
      } finally {
        this.loading = false
      }
    },
    handleChange(val) {
      this.$emit('change', val)
    },
    getSelected() {
      if (!this.value) {
        return
      }
      this.userValue = this.value.map((item) => item)
    },
    handleVisibleChange(val) {
      if (val) {
        this.userList = this.cloneUserList
      }
    },
    isOptionSelected(item) {
      if (this.userValue.indexOf(item.adminUid) > -1) {
        return false
      }
      if (item.deleted === 1) {
        return true
      }
      return false
    },
  },
}
</script>

<style lang="scss" scoped>
.width-layout {
  width: 100%;
}
</style>
